export default __webpack_public_path__ + "static/media/iranyekanwebregular.8dab3e13.svg";